import { BaseRecord } from "@refinedev/core";

export enum MatchStatus {
  PENDING = "PENDING",
  MATCHED = "MATCHED",
  MISMATCH = "MISMATCH",
}

export enum InvoiceStatus {
  PENDING = "PENDING",
  MATCHED = "MATCHED",
  SUBMITTED = "SUBMITTED",
  APPROVED = "APPROVED",
  PAID = "PAID",
  REJECTED = "REJECTED",
}

export interface InvoiceItem {
  poLineId: string;
  description: string;
  acceptedQty: number;
  invoicedQty: number;
  poUnitPrice: number;
  invoiceUnitPrice: number;
  matchStatus: MatchStatus;
  remarks?: string;
}

export interface Invoice extends BaseRecord {
  id: string;
  supplierId: string;
  supplierName: string;
  invoiceNumber: string;
  poId: string;
  poNumber: string;
  deliveryRefs: string[];
  currency: string;
  subtotal: number;
  tax: number;
  totalAmount: number;
  items: InvoiceItem[];
  matchStatus: MatchStatus;
  status: InvoiceStatus;
  fileId?: string;
  templateId?: string;
  approvalType?: string;
  externalWorkflow?: Record<string, any>;
  submittedBy?: string;
  paymentRequestId?: string;
  createdAt: Date;
  updatedAt: Date;
}